var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pet-icon"},[(_vm.gender === 0)?_c('img',{staticClass:"icon",style:({ width: _vm.iconWidth }),attrs:{"src":require("@/assets/icons/icon-female-sign.png")}}):_vm._e(),(_vm.gender === 1)?_c('img',{staticClass:"icon",style:({ width: _vm.iconWidth }),attrs:{"src":require("@/assets/icons/icon-male-sign.png")}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }